import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  TextField,
  Divider,
  Collapse,
  Stack,
  Tooltip,
  Box,
} from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";
import AddIcon from "@mui/icons-material/Add";
import { CancelOutlined } from "@mui/icons-material";

function FolderSelectionDialog({
  open,
  folders,
  selectedFolder,
  onFolderSelect,
  onCancel,
  onCreateFolder,
}) {
  const [creatingNewFolder, setCreatingNewFolder] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");

  const handleCreateFolderClick = () => {
    setCreatingNewFolder(true);
    setNewFolderName("");
  };

  const handleCancelCreate = () => {
    setCreatingNewFolder(false);
    setNewFolderName("");
  };

  const handleConfirmCreate = () => {
    if (newFolderName.trim()) {
      onCreateFolder(newFolderName.trim());
      setCreatingNewFolder(false);
      setNewFolderName("");
    }
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          backgroundColor: "#202020",
          color: "white",
        }}
      >
        Select a Folder
      </DialogTitle>
      <DialogContent dividers>
        <>
          <List disablePadding>
            <ListItem
              sx={{ pl: 2, pt: 0, pb: 0, fontWeight: "700", fontSize: 21 }}
            >
              Folders
            </ListItem>
            <Divider sx={{ pl: 2, px: 2, py: 0.5 }} />
            {folders
              .filter(
                (folder) =>
                  !folder.status ||
                  folder.status === "" ||
                  folder.status === "draft"
              )
              .map((folder) => (
                <ListItem
                  button
                  key={folder.folderId}
                  onClick={() => !creatingNewFolder && onFolderSelect(folder)}
                  selected={selectedFolder?.folderId === folder.folderId}
                  disabled={creatingNewFolder}
                  sx={{
                    px: 2,
                    py: 1,
                    borderRadius: 1,
                    mb: 0.5,
                    "&.Mui-selected": {
                      backgroundColor: "action.selected",
                      "&:hover": {
                        backgroundColor: "action.hover",
                      },
                    },
                  }}
                >
                  <ListItemIcon>
                    <FolderIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary={folder.folderName} />
                </ListItem>
              ))}
          </List>

          <List disablePadding>
            <ListItem
              sx={{
                pl: 2,
                pt: 0,
                pb: 0,
                fontWeight: "600",
                fontSize: 21,
                backgroundColor: "#ffebee", // Light red background
                borderRadius: 1,
                mb: 1,
                display: "flex",
                height: "4vh",
                alignItems: "center",
              }}
            >
              <span style={{ color: "#c62828" }}>Rejected Folders</span>
              {/* <CancelOutlined
                sx={{
                  color: "#c62828", // Dark red color
                  ml: 2,
                  fontSize: 20,
                }}
              /> */}
            </ListItem>
            {folders
              .filter((folder) => folder.status === "rejected")
              .map((folder) => (
                <ListItem
                  button
                  key={folder.folderId}
                  onClick={() => !creatingNewFolder && onFolderSelect(folder)}
                  selected={selectedFolder?.folderId === folder.folderId}
                  disabled={creatingNewFolder}
                  sx={{
                    px: 2,
                    py: 1,
                    borderRadius: 1,
                    mb: 0.5,
                    "&.Mui-selected": {
                      backgroundColor: "action.selected",
                      "&:hover": {
                        backgroundColor: "action.hover",
                      },
                    },
                  }}
                >
                  <ListItemIcon>
                    <FolderIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary={folder.folderName} />
                </ListItem>
              ))}
          </List>
        </>

        <Divider sx={{ my: 2 }} />

        {!creatingNewFolder ? (
          <Button
            variant="outlined"
            onClick={handleCreateFolderClick}
            fullWidth
            startIcon={<AddIcon />}
            sx={{ textTransform: "none" }}
          >
            Create New Folder
          </Button>
        ) : (
          <Collapse in={creatingNewFolder}>
            <Stack direction="row" spacing={1} alignItems="center" mt={1}>
              <TextField
                autoFocus
                label="New Folder Name"
                value={newFolderName}
                onChange={(e) => setNewFolderName(e.target.value)}
                fullWidth
                size="small"
                variant="outlined"
                inputProps={{ "aria-label": "New Folder Name" }}
              />
              <Tooltip title="Create Folder">
                <span>
                  <Button
                    variant="contained"
                    onClick={handleConfirmCreate}
                    disabled={!newFolderName.trim()}
                    color="primary"
                  >
                    Create
                  </Button>
                </span>
              </Tooltip>
              <Tooltip title="Cancel">
                <Button
                  variant="outlined"
                  onClick={handleCancelCreate}
                  color="secondary"
                >
                  Cancel
                </Button>
              </Tooltip>
            </Stack>
          </Collapse>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onCancel}
          disabled={creatingNewFolder}
          color="secondary"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default FolderSelectionDialog;
